import { useCallback } from "react";

export const useCheckboxHandler = (filters, handleFilterChange) => {
  const handleCheckboxChange = useCallback(
    (category) => {
      let checkedCount = 0;
      let lastCheckedCategory = null;

      const updatedMicroCategory = filters.microCategory.map(
        (microCategory) => {
          let updatedCategory = { ...microCategory };
          if (microCategory.name === category.name) {
            updatedCategory.checked = !updatedCategory.checked;
          }
          if (updatedCategory.checked) {
            checkedCount += 1;
            lastCheckedCategory = updatedCategory;
          }
          return updatedCategory;
        }
      );

      // If no checkboxes are checked, revert the last operation and return false
      if (
        checkedCount === 0 ||
        (checkedCount === 1 &&
          lastCheckedCategory &&
          !lastCheckedCategory.checked)
      ) {
        return false;
      }

      // Extract the names of the selected micro categories
      const selectedMicro = updatedMicroCategory
        .filter((category) => category.checked)
        .map((category) => category.name);

      handleFilterChange("microCategory", updatedMicroCategory);
      handleFilterChange("selectedMicro", selectedMicro);
    },
    [filters.microCategory, handleFilterChange]
  );

  return handleCheckboxChange;
};
